import * as React from "react";
import {
  AreaChart,
  Area,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip
} from "recharts";
import { parseApiDate } from "../../helpers/date";
import Select from "../../components/select";
import { IProfile } from "../../resources/user/types";
import styles from "./measurements.module.css";

interface IProps {
  profile: IProfile[];
}

const measurementsOptions: { id: string; title: string }[] = [
  { id: "bodyWeight", title: "Weight" },
  { id: "waistSize", title: "Waist" },
  { id: "hipSize", title: "Hip" },
  { id: "chestSize", title: "Chest" }
];

const measurementToLengthTitle: any = {
  bodyWeight: "Pounds",
  waistSize: "Inches",
  hipSize: "Inches",
  chestSize: "Inches"
};

export default function Measurements({ profile }: IProps) {
  const ref = React.useRef<any>(null);
  const [measurement, setMeasurement] = React.useState<string>("bodyWeight");

  const onMeasurementChange = (e: any) => setMeasurement(e.target.value);

  const measurementData = profile
    .sort((a, b) => a.timestamp - b.timestamp)
    .map((p: any) => ({
      x: parseApiDate(p.date).format("M/D/YY"),
      y: p[measurement]
    }));

  return (
    <div ref={ref}>
      <Select
        className={styles.select}
        value={measurement}
        onChange={onMeasurementChange}
      >
        {measurementsOptions.map(opt => (
          <option key={opt.id} value={opt.id}>
            {opt.title}
          </option>
        ))}
      </Select>
      {ref && profile.length > 0 ? (
        <AreaChart
          width={document.body.clientWidth - 20}
          height={200}
          data={measurementData}
          margin={{ top: 5, right: 5, bottom: 5, left: 0 }}
        >
          <defs>
            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#db4453" stopOpacity={0.8} />
              <stop offset="100%" stopColor="#db4453" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid vertical={false} stroke="#ccc" />
          <XAxis dataKey="x" minTickGap={20} interval="preserveStartEnd" />
          <YAxis tickCount={3} />
          <Tooltip
            formatter={(value: any) => {
              return [`${value} ${measurementToLengthTitle[measurement]}`, ""];
            }}
            separator=""
          />
          <Area
            type="monotone"
            dataKey="y"
            stroke="#db4453"
            fillOpacity={1}
            fill="url(#colorUv)"
          />
        </AreaChart>
      ) : null}
    </div>
  );
}
